module.exports = __webpack_public_path__ + "img/icon_smart_report.3371eaeb.png";